import React from 'react';
import ReactDOM from 'react-dom';
/** import css styles. */
import './assets/css/font.css';
import './assets/css/variables.css';
import './assets/css/global.css';

import RouterView from './router/RouterView';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <RouterView />

  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
